// TODO: LEGACY COMPONENT - DELETE AFTER FILTER FF REMOVED
import { gql, useLazyQuery } from '@apollo/client'
import Button from '@mui/material/Button'
import useFilter from '@promoboxx/use-filter'
import I18n from 'i18n-js'
import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { makeStyles } from 'tss-react/mui'

import RequestCampaignsDialog from '@src/components/content/RequestCampaignsDialog'
import LegacyRequestMoreCampaignsDialog from '@src/components/content/RequestMoreCampaignsDialog'
import { useFeatureFlag } from '@src/lib/useFeatureFlag'

import cloudinary from '../../lib/Cloudinary'
import colors from '../../lib/Colors'
import useModalState from '../../lib/useModalState'
import { currentRetailerAccountSelector } from '../../stores/app/selectors'
import { currentRetailerIdSelector } from '../../stores/retailers/selectors'
import LoadingCard from '../content/CampaignCardShimmer'
import SearchAndFilters from '../content/SearchAndFilters'
import SharedButton from '../shared/Button'
import LegacySvg from '../shared/LegacySvg'
import ShowMoreButton from '../shared/ShowMoreButton'

import CampaignCard from './CampaignCard'
import CampaignGroupHeader from './CampaignGroupHeader/index'

const useStyles = makeStyles()((theme) => ({
  noCampaignCard: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: ' center',
  },
  noCampaignsMessageAndCTA: {
    display: 'flex',
    flexDirection: 'column',
    color: colors.gray_300,
  },
  results: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    width: '100%',
    marginBottom: '24px',
  },
  showMore: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  noCampaignsAtAllMessageAndCTA: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(2),
    color: colors.gray_300,
  },
  requestMore: {
    color: theme.palette.promoboxx,
  },
}))

const normalizeChannelType = (channelName) => {
  switch (channelName) {
    case 'asset':
      return 'downloadables'
    case 'embed':
      return 'banner'
    default:
      return channelName
  }
}

const Results = ({ campaigns, onViewOrActivate, retailerAccount }) => {
  let results = []
  for (let i = 0; i < campaigns.length; i += 1) {
    const campaign = campaigns[i]
    const activateUrl = `/#/${retailerAccount.slug}/${campaign.brand.slug}/campaigns/${campaign.creative_path}/activate`
    let channels = []
    campaign.socials.forEach((social) => {
      const channel = normalizeChannelType(social.channel)
      channels.push({
        slug: campaign.slug,
        type: channel,
        to: `${activateUrl}/${channel}`,
        count: social.count,
      })
    })
    const localAdBalance = campaign.localAdBalances.reduce((acc, lab) => {
      return acc + lab.local_ads_balance
    }, 0)
    const sevenDaysAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
    const campaignProps = {
      activateUrl,
      cardImage: cloudinary.instance().url(campaign.logo_public_id, {
        background: 'auto:predominant',
        crop: 'pad',
        width: 500 * 2,
        height: 180 * 2,
        fetch_format: 'jpg',
        quality: 'auto',
      }),
      thumbnailSrc: campaign.logo_url,
      startDate: campaign.start_date,
      endDate: campaign.end_date,
      title: campaign.name,
      description: campaign.description,
      brandLogo: campaign.brand.logo_url,
      type: localAdBalance ? 'localAd' : 'campaign',
      isActivated:
        campaign.invitation &&
        campaign.invitation.state &&
        campaign.invitation.state === 'engaged',
      channels,
      creditAmount: localAdBalance,
      sash:
        ((campaign.invitation &&
          campaign.invitation.state &&
          campaign.invitation.state === 'engaged' &&
          campaign.invitation.status !== 'accepted') ||
          campaign.invitation.state !== 'engaged') &&
        new Date(campaign.invitation.created_at) >= sevenDaysAgo,
    }
    //Eww all this normalizing...
    results.push(
      <CampaignCard
        {...campaignProps}
        index={i}
        key={`campaign-${campaign.id}-${i}`}
        onViewOrActivate={onViewOrActivate(activateUrl)}
      />,
    )
  }
  return results
}

const LoadingResults = ({ show }) => {
  let results = []
  for (let i = 0; i < show; i += 1) {
    const key = `loading-card-${i}`
    results.push(<LoadingCard key={key} />)
  }
  return results
}

const EmptyResults = ({ resetFilters }) => {
  const { classes } = useStyles()
  return (
    <div className={classes.noCampaignCard}>
      <LegacySvg height={'250px'} symbol={'empty-content-man'} />
      <div className={classes.noCampaignsMessageAndCTA}>
        <p>{I18n.t('content.noCampaignsFound')}</p>
        <SharedButton onClick={resetFilters}>
          {I18n.t('shared.resetSearch')}
        </SharedButton>
      </div>
    </div>
  )
}

const GET_CAMPAIGNS_SEARCH = gql`
  query LegacyGetCampaignsSearchContentPage(
    $resourceType: CampaignSearchResourceType!
    $resourceId: ID!
    $params: CampaignSearchParams
  ) {
    getCampaignSearch(
      resourceType: $resourceType
      resourceId: $resourceId
      params: $params
    ) {
      data {
        id
        name
        start_date
        end_date
        brand {
          id
          logo_url
          slug
        }
        creative_path
        description
        logo_public_id
        invitation {
          id
          state
          created_at
          status
        }
        socials {
          channel
          count
        }
        localAdBalances {
          id
          local_ads_balance
        }
      }
      paging {
        total_results
      }
    }
  }
`

const PAGE_SIZE = 6

const OrganicCampaigns = () => {
  const { classes } = useStyles()
  const useNewContentRequests = useFeatureFlag('new-content-requests')
  const retailerAccount = useSelector(currentRetailerAccountSelector)
  const retailerId = useSelector(currentRetailerIdSelector)
  const [campaigns, setCampaigns] = useState([])

  const [getCampaignSearch, { data, error, refetch, called }] =
    useLazyQuery(GET_CAMPAIGNS_SEARCH)
  const filterInfo = useFilter('content.organic_campaigns', {
    shouldForceRunOnMount: true,
    defaultFilterInfo: {
      filter: {
        filterByValue: 0,
        showValue: 0,
        tagsValues: [],
        searchValue: null,
      },
      pageSize: PAGE_SIZE,
    },
    onChange(filterInfo) {
      let params = {
        per_page: PAGE_SIZE,
        offset: filterInfo.offset,
      }
      let filterParams = {}
      if (filterInfo.filter.tagsValues) {
        params.tags = filterInfo.filter.tagsValues
      }
      if (filterInfo.filter.searchValue) {
        params.search = filterInfo.filter.searchValue
      }
      if (
        filterInfo.filter.filterByValue &&
        filterInfo.filter.filterByValue !== 0
      ) {
        filterParams[filterInfo.filter.filterByValue] = true
        params.filterParams = filterParams
      }
      if (filterInfo.filter.showValue && filterInfo.filter.showValue !== 0) {
        filterParams.show_state = filterInfo.filter.showValue
        params.filterParams = filterParams
      }
      const variables = {
        resourceId: retailerId ? retailerId : retailerAccount.id,
        resourceType: retailerId ? 'retailers' : 'retailer_accounts',
        params,
      }
      return (called ? refetch(variables) : getCampaignSearch({ variables }))
        .then((response) => {
          return {
            filterInfo: {
              totalResults:
                (response.data &&
                  response.data.getCampaignSearch &&
                  response.data.getCampaignSearch.paging &&
                  response.data.getCampaignSearch.paging.total_results) ||
                0,
            },
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
  })

  useEffect(() => {
    if (
      filterInfo.isLoading === false &&
      data &&
      data.getCampaignSearch &&
      data.getCampaignSearch.data
    ) {
      setCampaigns([...campaigns, ...data.getCampaignSearch.data])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, filterInfo.isLoading])

  useEffect(() => {
    if (error) {
      setCampaigns([])
      console.error(error)
    }
  }, [error])

  useEffect(() => {
    // the `retailerIds` value in the filter is only the default, when it
    // changes the filter doesn't run on its own.
    // since it comes from redux we have to put it in as a side effect.
    // we don't want it to run on mount, cause that causes issues in
    // `useFilter` (it relies on one pass for things to settle).
    // piggy backing off of `called` here. technically any sort of "did the
    // filter run once" logic would work here.
    if (called) {
      setCampaigns([])
      filterInfo.updateFilter({
        retailerIds: [retailerId],
        retailerAccountId: retailerAccount.id,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [retailerId, retailerAccount.id])

  const onFiltersChange = (key, value) => {
    setCampaigns([])
    filterInfo.updateFilter({ [key]: value })
  }

  const resetFilters = () => {
    filterInfo.resetFilter()
  }

  const onViewOrActivateHandler = (activateUrl) => {
    return (event, channelUrl) => {
      event.preventDefault()
      setTimeout(function () {
        window.location = channelUrl ? channelUrl : activateUrl
      }, 0)
    }
  }

  const showMoreButtonHandler = () => {
    filterInfo.setPage(filterInfo.filterInfo.page + 1)
  }

  const { isOpen, toggleModal } = useModalState()

  const showRequestMore =
    (!filterInfo.isLoading &&
      filterInfo.filterInfo.totalResults === campaigns.length) ||
    campaigns.length === 0

  return (
    <CampaignGroupHeader
      count={filterInfo.filterInfo.totalResults}
      title={I18n.t('content.organicCampaignsHeader')}
    >
      <SearchAndFilters onChange={onFiltersChange} />
      <div className={classes.results}>
        {!filterInfo.isLoading && filterInfo.filterInfo.totalResults === 0 && (
          <EmptyResults resetFilters={resetFilters} />
        )}
        {campaigns.length > 0 && (
          <Results
            campaigns={campaigns}
            onViewOrActivate={onViewOrActivateHandler}
            retailerAccount={retailerAccount}
          />
        )}
        {filterInfo.isLoading && <LoadingResults show={PAGE_SIZE} />}
        {!filterInfo.isLoading && campaigns.length > 0 && (
          <div className={classes.showMore}>
            <ShowMoreButton
              numberShown={(campaigns && campaigns.length) || 0}
              onClick={showMoreButtonHandler}
              total={filterInfo.filterInfo.totalResults}
            />
          </div>
        )}
        {!filterInfo.isLoading && showRequestMore && (
          <>
            {campaigns.length === 0 && (
              <>
                <div className={classes.noCampaignsAtAllMessageAndCTA}>
                  <p>{I18n.t('content.noCampaignsAtAll')}</p>
                </div>
                <br />
              </>
            )}
            <div className={classes.showMore}>
              <Button
                color="secondary"
                onClick={toggleModal}
                size="large"
                variant="outlined"
              >
                {I18n.t('content.requestMore')}
              </Button>
            </div>
          </>
        )}
      </div>
      {useNewContentRequests ? (
        <RequestCampaignsDialog
          onClose={toggleModal}
          open={isOpen}
          total={filterInfo.filterInfo.totalResults}
        />
      ) : (
        <LegacyRequestMoreCampaignsDialog
          onClose={toggleModal}
          open={isOpen}
          total={filterInfo.filterInfo.totalResults}
        />
      )}
    </CampaignGroupHeader>
  )
}

export default OrganicCampaigns
